import React, { useState, useEffect, useRef } from 'react';
import { Button, Card, Container, Tab, Form, Row, Col, Alert, Spinner, Modal } from 'react-bootstrap';
import { fetchGetData, fetchPostData, fetchFormData } from './api'; // Import your common API file
import { Popover, OverlayTrigger, Table } from 'react-bootstrap';

import { AgGridReact } from 'ag-grid-react';
import { ClientSideRowModelModule } from 'ag-grid-community';
import { ValidationModule } from 'ag-grid-community';


const TrackEmployee = () => {
    const [paymentType, setPaymentType] = useState(''); // Advance Payment or Full Payment
    const [amountAfterPercentage, setAmountAfterPercentage] = useState('');
    const [advancePending, setAdvancePending] = useState('');
    const [loading, setLoading] = useState(false);
    const [billingHistory, setBillingHistory] = useState([]);
    const [checkLoading, setCheckLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [companyName, setCompanyName] = useState(''); // 67ad84f7d17c41149ecd63c9,6765345d455383ea43aa2897
    const [vacancyName, setVacancyName] = useState('');
    const [jobVacancy, setVacancy] = useState([]);
    const [searchTitle, setSearchTitle] = useState('');
    const [noOfCandidates, setNoOfCandidates] = useState('');
    const [salary, setSalary] = useState('');
    const [paidAmount, setPaidAmount] = useState('');
    const [transactionID, setTransactionID] = useState('');
    const [percentage, setPercentage] = useState('');
    const [paymentMode, setPaymentMode] = useState('');//Axis Bank
    const [CGST, setCGST] = useState('0');
    const [SGST, setSGST] = useState('0');
    const [totalAmount, setTotalAmount] = useState('');
    const [description, setDescription] = useState('');
    const [executive, setExecutive] = useState('');
    const [jobExecutive, setJobExecutive] = useState([]);
    const [jobEmployer, setEmployer] = useState([]);
    const [excelData, setExcelData] = useState([]);
    const [isEditing, setIsEditing] = useState(false);
    const [editRecordId, setEditRecordId] = useState(null);
    const [expandedRows, setExpandedRows] = useState({}); // Track expanded rows
    const [showModal, setShowModal] = useState(false);
    const [selectedVacancyName, setSelectedVacancyName] = useState('');
    const [vacancyDetails, setVacancyDetails] = useState([]);
    const [allData, setAllData] = useState([]);


    // useEffect(() => {
    //     if (salary && percentage) {
    //         const numericSalary = parseFloat(salary.toString().replace(/,/g, ''));
    //         const numericPercentage = parseFloat(percentage);
    //         if (isNaN(numericSalary) || isNaN(numericPercentage)) return;

    //         const amtAfterPercent = numericSalary * (numericPercentage / 100);
    //         setAmountAfterPercentage(formatWithCommas(amtAfterPercent));

    //         // Calculate Advance Pending if paid amount exists
    //         const numericPaid = parseFloat(paidAmount.toString().replace(/,/g, '')) || 0;

    //         if (numericPaid < amtAfterPercent) {
    //             const pending = amtAfterPercent - numericPaid;
    //             setAdvancePending(formatWithCommas(pending));
    //         } else {
    //             setAdvancePending(''); // No pending if paid >= required
    //         }
    //     } else {
    //         setAmountAfterPercentage('');
    //         setAdvancePending('');
    //     }
    // }, [salary, percentage, paidAmount]);

    // useEffect(() => {
    //     if (salary && percentage) {
    //         const numericSalary = parseFloat(salary.toString().replace(/,/g, ''));
    //         const numericPercentage = parseFloat(percentage);
    //         if (isNaN(numericSalary) || isNaN(numericPercentage)) return;

    //         const amtAfterPercent = numericSalary * (numericPercentage / 100);
    //         setAmountAfterPercentage(formatWithCommas(amtAfterPercent));

    //         // Prefill paidAmount if it hasn't been manually changed yet.
    //         if (!paidAmount || paidAmount === '') {
    //             // Setting as a plain number string so the number input works properly.
    //             setPaidAmount(amtAfterPercent.toFixed(2));
    //         }

    //         // Calculate Advance Pending based on current paidAmount
    //         const numericPaid = parseFloat(paidAmount.toString().replace(/,/g, '')) || 0;
    //         if (numericPaid < amtAfterPercent) {
    //             const pending = amtAfterPercent - numericPaid;
    //             setAdvancePending(formatWithCommas(pending));
    //         } else {
    //             setAdvancePending('');
    //         }
    //     } else {
    //         setAmountAfterPercentage('');
    //         setAdvancePending('');
    //     }
    // }, [salary, percentage, paidAmount]);


    // useEffect(() => {
    //     if (salary && percentage) {
    //       const numericSalary = parseFloat(salary.toString().replace(/,/g, ''));
    //       const numericPercentage = parseFloat(percentage);
    //       if (isNaN(numericSalary) || isNaN(numericPercentage)) return;

    //       const amtAfterPercent = numericSalary * (numericPercentage / 100);
    //       setAmountAfterPercentage(formatWithCommas(amtAfterPercent));

    //       // Always update the paid amount so that it mirrors the calculated value
    //       setPaidAmount(amtAfterPercent.toFixed(2));

    //       // Calculate advance pending; in this case it will be zero since paid amount equals the calculated amount.
    //       const numericPaid = parseFloat(amtAfterPercent) || 0;
    //       if (numericPaid < amtAfterPercent) {
    //         const pending = amtAfterPercent - numericPaid;
    //         setAdvancePending(formatWithCommas(pending));
    //       } else {
    //         setAdvancePending('');
    //       }
    //     } else {
    //       setAmountAfterPercentage('');
    //       setAdvancePending('');
    //     }
    //   }, [salary, percentage]);
    // useEffect(() => {
    //     if (salary && percentage && noOfCandidates) {
    //       const numericSalary = parseFloat(salary.toString().replace(/,/g, ''));
    //       const numericPercentage = parseFloat(percentage);
    //       const numericCandidates = parseFloat(noOfCandidates) || 1; // Default to 1 if empty

    //       if (isNaN(numericSalary) || isNaN(numericPercentage) || isNaN(numericCandidates)) return;

    //       // Calculate base amount for one candidate
    //       const baseAmount = numericSalary * (numericPercentage / 100);

    //       // Multiply by number of candidates
    //       const amtAfterPercent = baseAmount * numericCandidates;

    //       setAmountAfterPercentage(formatWithCommas(amtAfterPercent));

    //       // Always update the paid amount to match the calculated value
    //       setPaidAmount(amtAfterPercent.toFixed(2));

    //       // Calculate advance pending (will be zero since paid amount equals calculated amount)
    //       const numericPaid = parseFloat(amtAfterPercent) || 0;
    //       if (numericPaid < amtAfterPercent) {
    //         const pending = amtAfterPercent - numericPaid;
    //         setAdvancePending(formatWithCommas(pending));
    //       } else {
    //         setAdvancePending('');
    //       }
    //     } else {
    //       setAmountAfterPercentage('');
    //       setAdvancePending('');
    //     }
    //   }, [salary, percentage, noOfCandidates]);



    useEffect(() => {
        if (salary && percentage && noOfCandidates) {
            const numericSalary = parseFloat(salary.toString().replace(/,/g, ''));
            const numericPercentage = parseFloat(percentage);
            const numericCandidates = parseFloat(noOfCandidates) || 1; // Default to 1 if empty

            if (isNaN(numericSalary) || isNaN(numericPercentage) || isNaN(numericCandidates)) return;

            // Calculate the full required amount for the vacancy
            const fullAmount = numericSalary * (numericPercentage / 100) * numericCandidates * 1.18;
            setAmountAfterPercentage(formatWithCommas(fullAmount));

            // Check if billing history exists for this vacancy
            let remainingAmount = fullAmount;
            if (billingHistory && billingHistory.length > 0) {
                // Sum up all previous paid amounts
                const totalPaid = billingHistory.reduce((acc, record) => {
                    return acc + parseFloat(record.paidAmount);
                }, 0);
                remainingAmount = fullAmount - totalPaid;
            }

            // Prefill the paidAmount field with the remaining amount
            setPaidAmount(remainingAmount.toFixed(2));

            // (Optional) You can also calculate an "advance pending" if needed:
            if (remainingAmount < fullAmount) {
                const pending = fullAmount - remainingAmount;
                setAdvancePending(formatWithCommas(pending));
            } else {
                setAdvancePending('');
            }
        } else {
            setAmountAfterPercentage('');
            setAdvancePending('');
        }
    }, [salary, percentage, noOfCandidates, billingHistory]);


    useEffect(() => {
        if (paidAmount) {
            const numericPaid = parseFloat(paidAmount.toString().replace(/,/g, '')) || 0;
            const baseAmt = numericPaid / 1.18; // Calculate base amount before GST
            setTotalAmount(baseAmt.toFixed(2));
            setCGST((baseAmt * 0.09).toFixed(2));
            setSGST((baseAmt * 0.09).toFixed(2));
        } else {
            // Optionally, clear the GST values when paidAmount is empty
            setTotalAmount('');
            setCGST('0');
            setSGST('0');
        }
    }, [paidAmount]);



    const formatWithCommas = (value) => {
        return parseFloat(value).toLocaleString('en-IN', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    };


    // Add this function inside your component
    // const handleVacancyChange = (e) => {
    //     const selectedVacancyId = e.target.value;
    //     setVacancyName(selectedVacancyId);
    //     const selectedVacancy = jobVacancy.find(vacancy => vacancy._id === selectedVacancyId);
    //     if (selectedVacancy) {
    //         setSalary(selectedVacancy.salary?.toString() || '');
    //         setPercentage(selectedVacancy.percentage?.toString() || '');
    //         setNoOfCandidates(selectedVacancy.selectedCount?.toString() || '');

    //     } else {
    //         setSalary('');
    //         setPercentage('');
    //         setNoOfCandidates('');


    //     }
    //     // Reset the paid amount field on job title change
    //     setPaidAmount('');
    // };


    // const handleVacancyChange = (e) => {
    //     const selectedVacancyId = e.target.value;
    //     setVacancyName(selectedVacancyId);
    //     const selectedVacancy = jobVacancy.find(vacancy => vacancy._id === selectedVacancyId);
    //     if (selectedVacancy) {
    //         setSalary(selectedVacancy.salary?.toString() || '');
    //         setPercentage(selectedVacancy.percentage?.toString() || '');

    //         // Prefill noOfCandidates with selectedCount if > 0, otherwise use noOfCandidates from vacancy
    //         const candidateCount = selectedVacancy.selectedCount > 0
    //             ? selectedVacancy.selectedCount
    //             : selectedVacancy.noOfCandidates;
    //         setNoOfCandidates(candidateCount?.toString() || '');

    //     } else {
    //         setSalary('');
    //         setPercentage('');
    //         setNoOfCandidates('');
    //     }
    //     // Reset the paid amount field on job title change
    //     setPaidAmount('');
    // };


    // const handleVacancyChange = (e) => {
    //     const selectedVacancyId = e.target.value;
    //     setVacancyName(selectedVacancyId);
    //     const selectedVacancy = jobVacancy.find(vacancy => vacancy._id === selectedVacancyId);

    //     if (selectedVacancy) {
    //       setSalary(selectedVacancy.salary?.toString() || '');
    //       setPercentage(selectedVacancy.percentage?.toString() || '');

    //       // Use selectedCount if > 0, otherwise use noOfCandidates from vacancy
    //       const candidateCount = selectedVacancy.selectedCount > 0
    //         ? selectedVacancy.selectedCount
    //         : selectedVacancy.noOfCandidates;

    //       setNoOfCandidates(candidateCount?.toString() || '1'); // Default to '1' if empty
    //     } else {
    //       setSalary('');
    //       setPercentage('');
    //       setNoOfCandidates('1'); // Reset to '1' if no vacancy selected
    //     }

    //     // Reset the paid amount field on job title change
    //     setPaidAmount('');
    //   };

    const handleVacancyChange = (e) => {
        const selectedVacancyId = e.target.value;
        setVacancyName(selectedVacancyId);
        const selectedVacancy = jobVacancy.find(vacancy => vacancy._id === selectedVacancyId);

        if (selectedVacancy) {
            setSalary(selectedVacancy.salary?.toString() || '');
            setPercentage(selectedVacancy.percentage?.toString() || '');

            const match = jobEmployer.find(job => job._id === companyName);
            if (match) {
                setExecutive(match.executive); // or whatever you want to set here
            }
            // Use selectedCount if > 0, otherwise use noOfCandidates from vacancy
            const candidateCount = selectedVacancy.selectedCount > 0
                ? selectedVacancy.selectedCount
                : selectedVacancy.noOfCandidates;

            setNoOfCandidates(candidateCount?.toString() || '1'); // Default to '1' if empty

            // Display billing history if available
            if (selectedVacancy.billingHistory && selectedVacancy.billingHistory.length > 0) {
                console.log("Billing History:", selectedVacancy.billingHistory);
                // You can set this to state if you want to display it in your UI
                setBillingHistory(selectedVacancy.billingHistory);
            } else {
                console.log("No billing history found for this vacancy");
                setBillingHistory([]);
            }
        } else {
            setSalary('');
            setPercentage('');
            setNoOfCandidates('1'); // Reset to '1' if no vacancy selected
            setBillingHistory([]);
        }

        // Reset the paid amount field on job title change
        setPaidAmount('');
    };

    const getCurrentDate = () => {
        const today = new Date();
        today.setDate(today.getDate() + 2); // Add 1 to the current date
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so add 1
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    const modeArray = [
        {
            name: 'Select Mode',
            val: '',
        },
        {
            name: 'Axis Bank',
            val: 'Axis Bank',
        },
        {
            name: 'RBL Bank',
            val: 'RBL Bank',
        },
        {
            name: 'Google Pay',
            val: 'Google Pay',
        },
        {
            name: 'Pay U Money',
            val: 'Pay U Money',
        },
        {
            name: 'Cash',
            val: 'Cash',
        },
        {
            name: 'Offer',
            val: 'Offer',
        },
        {
            name: 'Razorpay',
            val: 'Razorpay',
        },
        {
            name: 'Paytm',
            val: 'Paytm',
        },
        {
            name: 'Phonepe',
            val: 'Phonepe',
        }];
    const [minDate, setMinDate] = useState(getCurrentDate());
    const [payDate, setPayDate] = useState(''); //2025-02-17

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [relavantList, setRelavantList] = useState({
        title: [],
        course: []
    });
    const [employerPayProof, setEmployerPayProof] = useState(null);
    const [preview, setPreview] = useState(null);

    const maxSize = 5 * 1024 * 1024; // 5MB size limit
    const fileInputRef = useRef(null); // Create a ref for the file input

    // const handleEdit = (data) => {
    //     setCompanyName(data.employerid);

    //     // Ensure job vacancies for the selected employer are fetched
    //     fetchData(data.employerid).then(() => {
    //         // Find the corresponding vacancy ID based on job title
    //         const matchedVacancy = jobVacancy.find(vacancy => vacancy.jobtitle === data.vacancyName);

    //         setVacancyName(matchedVacancy ? matchedVacancy._id : '');
    //     });

    //     setNoOfCandidates(data.candidate_count);
    //     setSalary(data.salary);
    //     setPaidAmount(data.paidAmount);
    //     setTransactionID(data.transactionID);
    //     setPercentage(data.percentage);
    //     setPaymentMode(data.paymentMode);
    //     setCGST(data.CGST);
    //     setSGST(data.SGST);
    //     setTotalAmount(data.totalAmount);

    //     const formattedDate = data.payDate ? data.payDate.split("T")[0] : '';
    //     setPayDate(formattedDate);

    //     setDescription(data.description);
    //     setPreview(data.employerPayProof);

    //     setIsEditing(true);
    //     setEditRecordId(data._id);
    // };



    // const handleEdit = async (data) => {
    //     setCompanyName(data.employerid);

    //     try {
    //         // Fetch job vacancies for the selected employer
    //         const jobVacancyResponse = await fetchGetData('/employer/get/employer/vacancy', { id: data.employerid });

    //         if (jobVacancyResponse.success) {
    //             const vacancies = jobVacancyResponse.data;
    //             setVacancy(vacancies);

    //             // Find the vacancy that matches the job title
    //             const matchedVacancy = vacancies.find(vacancy => vacancy.jobtitle === data.vacancyName);

    //             // Set the matching vacancy _id
    //             setVacancyName(matchedVacancy ? matchedVacancy._id : '');
    //         } else {
    //             console.error("Failed to fetch job vacancies");
    //         }
    //     } catch (error) {
    //         console.error("Error fetching job vacancies:", error);
    //     }

    //     setNoOfCandidates(data.candidate_count);
    //     setSalary(data.salary);
    //     setPaidAmount(data.paidAmount);
    //     setTransactionID(data.transactionID);
    //     setPercentage(data.percentage);
    //     setPaymentMode(data.paymentMode);
    //     setCGST(data.CGST);
    //     setSGST(data.SGST);
    //     setTotalAmount(data.totalAmount);

    //     // Format and set pay date
    //     const formattedDate = data.payDate ? data.payDate.split("T")[0] : '';
    //     setPayDate(formattedDate);

    //     setDescription(data.description);
    //     setPreview(data.employerPayProof);

    //     setIsEditing(true);
    //     setEditRecordId(data._id);
    // };


    const handleEdit = async (data) => {
        // Scroll to the top of the page
        window.scrollTo({ top: 0, behavior: 'smooth' });

        setCompanyName(data.employerid);

        try {
            // Fetch job vacancies for the selected employer
            const jobVacancyResponse = await fetchGetData('/employer/get/employer/vacancy', { id: data.employerid });

            if (jobVacancyResponse.success) {
                const vacancies = jobVacancyResponse.data;
                setVacancy(vacancies);

                // Find the matching vacancy asynchronously
                const matchedVacancy = vacancies.find(vacancy => vacancy._id === data.vacancyName);

                // Ensure state update happens after vacancies are set
                setTimeout(() => {
                    setVacancyName(matchedVacancy ? matchedVacancy._id : '');
                }, 100);
            } else {
                console.error("Failed to fetch job vacancies");
            }
        } catch (error) {
            console.error("Error fetching job vacancies:", error);
        }

        setNoOfCandidates(data.candidate_count);
        setSalary(data.salary);
        setPaidAmount(data.paidAmount);
        setTransactionID(data.transactionID);

        setPercentage(data.percentage);
        setPaymentMode(data.paymentMode);
        setCGST(data.CGST);
        setSGST(data.SGST);
        setTotalAmount(data.totalAmount);

        // Format and set pay date
        const formattedDate = data.payDate ? data.payDate.split("T")[0] : '';
        setPayDate(formattedDate);

        setDescription(data.description);
        setPreview(data.employerPayProof);

        setIsEditing(true);
        setEditRecordId(data._id);
    };



    // Add this handler in your component
    const handleViewAdvanceInvoice = (partialPaymentId) => {
        if (!partialPaymentId) {
            alert("Advance invoice ID not found!");
            return;
        }
        // Open the advance invoice in a new tab (adjust the URL as needed)
        window.open(`https://staffing.nithrajobs.com/invoiceDetails?i=${partialPaymentId}`, '_blank');
    };
    const handleDetailsClick = (vacancyName) => {
        // alert(vacancyName)
        const matchingRecords = allData.filter(item => item.vacancyName === vacancyName);
        setVacancyDetails(matchingRecords);
        setSelectedVacancyName(vacancyName);
        setShowModal(true);
        // console.log(matchingRecords)
    };
    //
    //     const columnsStaffing = [
    //         { headerName: "S. No", valueGetter: (params) => params.node.rowIndex + 1, width: 80 },

    //         // {
    //         //     headerName: "Edit",
    //         //     field: "edit",
    //         //     cellRenderer: (params) => (
    //         //         <Button
    //         //             variant="primary"
    //         //             size="sm"
    //         //             onClick={() => handleEdit(params.data)}
    //         //         >
    //         //             ✏️ Edit
    //         //         </Button>
    //         //     ),
    //         //     width: 100,
    //         // },
    //         { headerName: "Comapany Name", field: "companyName" },
    //         {
    //             headerName: "Invoice",
    //             field: "action",
    //             cellRenderer: (params) => {
    //                 return (
    //                     <Button
    //                         variant="warning"
    //                         size="sm"
    //                         onClick={() => handleViewInvoice(params.data)}
    //                     >
    //                         🧾
    //                     </Button>
    //                 );
    //             },
    //             width: 100,
    //         },
    //         {
    //             headerName: "Payment Type",
    //             field: "paymentType",
    //             valueFormatter: (params) => {
    //               // Check if this billing record includes advance (partial) payments
    //               if (params.data.partialPaymentIds && params.data.partialPaymentIds.length > 0) {
    //                 return "Advance + Full Payment";
    //               }
    //               return "Full Payment";
    //             }
    //           }
    // ,            {
    //     headerName: "Advance Payment Invoice Receipt",
    //     field: "advanceInvoiceReceipt",
    //     cellRenderer: (params) => {
    //       // Only render button if this record includes advance payment info.
    //       if (params.data.partialPaymentIds && params.data.partialPaymentIds.length > 0) {
    //         // Use the most recent partial payment invoice (or choose appropriate index)
    //         const advanceInvoiceId = params.data.partialPaymentIds[params.data.partialPaymentIds.length - 1];
    //         return (
    //           <Button
    //             variant="info"
    //             size="sm"
    //             onClick={() => handleViewAdvanceInvoice(advanceInvoiceId)}
    //           >
    //             View Advance Invoice
    //           </Button>
    //         );
    //       }
    //       return ""; // Render nothing if no advance payment exists
    //     },
    //     cellStyle: { textAlign: 'center' },
    //     width: 220
    //   },
    //         { headerName: "Invoice Number", field: "invoiceNumber" },
    //         { headerName: "TransactionID", field: "transactionID" },
    //         { headerName: "Salary", field: "salary" },
    //         { headerName: "Percentage", field: "percentage" },
    //         { headerName: "Paid Amount", field: "paidAmount" },
    //         { headerName: "CGST", field: "CGST" },
    //         { headerName: "SGST", field: "SGST" },
    //         { headerName: "Total Amount", field: "totalAmount" },
    //         { headerName: "Payment Mode", field: "paymentMode" },
    //         // { headerName: "Pay Date", field: "payDate" },
    //         {
    //             headerName: "Pay Date",
    //             field: "payDate",
    //             valueFormatter: (params) => {
    //                 if (!params.value) return "";
    //                 const date = new Date(params.value);
    //                 return date.toLocaleDateString("en-GB", {
    //                     day: "2-digit",
    //                     month: "2-digit",
    //                     year: "numeric",
    //                 });
    //             }
    //         },

    //         { headerName: "Candidate Count", field: "candidate_count" },
    //         { headerName: "Description", field: "description" },


    //         {
    //             headerName: "Created on",
    //             field: "createdAt",
    //             valueFormatter: (params) => {
    //                 if (!params.value) return "";
    //                 const date = new Date(params.value);
    //                 return date.toLocaleDateString("en-US", {
    //                     year: "numeric",
    //                     month: "long",
    //                     day: "numeric",
    //                 });
    //             }
    //         }];


    // const columnsStaffing = [
    //     { headerName: "S. No", valueGetter: (params) => params.node.rowIndex + 1, width: 80 },
    //     { headerName: "Company Name", field: "companyName" },
    //     {
    //       headerName: "Invoice",
    //       field: "action",
    //       cellRenderer: (params) => (
    //         <Button
    //           variant="warning"
    //           size="sm"
    //           onClick={() => handleViewInvoice(params.data)}
    //         >
    //           🧾
    //         </Button>
    //       ),
    //       width: 100,
    //     },
    //     { headerName: "Invoice Number", field: "invoiceNumber" },
    //     { headerName: "TransactionID", field: "transactionID" },
    //     { headerName: "Salary", field: "salary" },
    //     { headerName: "Percentage", field: "percentage" },
    //     { headerName: "Paid Amount", field: "paidAmount" },
    //     { headerName: "CGST", field: "CGST" },
    //     { headerName: "SGST", field: "SGST" },
    //     { headerName: "Total Amount", field: "totalAmount" },
    //     { headerName: "Payment Mode", field: "paymentMode" },
    //     {
    //       headerName: "Payment Type",
    //       field: "paymentType",
    //       valueFormatter: (params) => {
    //         if (params.data.partialPaymentIds && params.data.partialPaymentIds.length > 0) {
    //           return "Advance + Full Payment";
    //         }
    //         return "Full Payment";
    //       },
    //       cellStyle: (params) => {
    //         if (params.data.partialPaymentIds && params.data.partialPaymentIds.length > 0) {
    //           return { color: 'red' };
    //         }
    //         return { color: 'green' };
    //       }
    //     },
    //     {
    //       headerName: "Advance Payment Invoice Receipt",
    //       field: "advanceInvoiceReceipt",
    //       cellRenderer: (params) => {
    //         if (params.data.partialPaymentIds && params.data.partialPaymentIds.length > 0) {
    //           // Choose one (or any logic) to view a specific advance invoice
    //           const advanceInvoiceId = params.data.partialPaymentIds[params.data.partialPaymentIds.length - 1];
    //           return (
    //             <Button
    //               variant="info"
    //               size="sm"
    //               onClick={() => handleViewAdvanceInvoice(advanceInvoiceId)}
    //             >
    //               View Advance Invoice
    //             </Button>
    //           );
    //         }
    //         return "";
    //       },
    //       cellStyle: { textAlign: 'center' },
    //       width: 220
    //     },
    //     {
    //       headerName: "View Advance Details",
    //       field: "viewAdvanceDetails",
    //       cellRenderer: (params) => {
    //         // Only render if there are advance payments (partialPaymentIds exists and is non-empty)
    //         if (params.data.partialPaymentIds && params.data.partialPaymentIds.length > 0) {
    //           return (
    //             <Button
    //               variant="secondary"
    //               size="sm"
    //               onClick={() => handleViewAdvanceDetails(params.data)}
    //             >
    //               View Advance Details
    //             </Button>
    //           );
    //         }
    //         return "";
    //       },
    //       cellStyle: { textAlign: 'center' },
    //       width: 200
    //     },
    //     {
    //       headerName: "Pay Date",
    //       field: "payDate",
    //       valueFormatter: (params) => {
    //         if (!params.value) return "";
    //         const date = new Date(params.value);
    //         return date.toLocaleDateString("en-GB", {
    //           day: "2-digit",
    //           month: "2-digit",
    //           year: "numeric",
    //         });
    //       },
    //     },
    //     { headerName: "Candidate Count", field: "candidate_count" },
    //     { headerName: "Description", field: "description" },
    //     {
    //       headerName: "Created on",
    //       field: "createdAt",
    //       valueFormatter: (params) => {
    //         if (!params.value) return "";
    //         const date = new Date(params.value);
    //         return date.toLocaleDateString("en-US", {
    //           year: "numeric",
    //           month: "long",
    //           day: "numeric",
    //         });
    //       },
    //     },
    //   ];


    // In your AG Grid column definitions:
    const columnsStaffing = [
        { headerName: "S. No", valueGetter: (params) => params.node.rowIndex + 1, width: 80 },
        { headerName: "Company Name", field: "companyName" },
        {
            headerName: "Payment Type",
            field: "paymentType",
            valueFormatter: (params) => {
                if (params.data.collectionType === 'payment') {
                    // Record from the payment collection indicates an advance payment.
                    return "Advance Payment";
                } else if (params.data.collectionType === 'billing') {
                    // Record from billing: if there were prior partial payments, show combined type.
                    if (params.data.partialPaymentIds && params.data.partialPaymentIds.length > 0) {
                        return "Advance + Full Payment";
                    }
                    return "Full Payment";
                }
                return "";
            },
            cellStyle: (params) => {
                if (params.data.collectionType === 'payment') {
                    return { color: 'orange' }; // Customize as needed for advance payments
                } else if (params.data.collectionType === 'billing') {
                    if (params.data.partialPaymentIds && params.data.partialPaymentIds.length > 0) {
                        return { color: 'red' };
                    }
                    return { color: 'green' };
                }
                return {};
            }
        },
        {
            headerName: 'Actions',
            cellRenderer: (params) => (
                <Button
                    variant="primary"
                    size="sm"
                    onClick={() => handleDetailsClick(params.data.vacancyName)}
                >
                    👁️‍🗨️
                </Button>
            ),
            width: 80
        },
        {
            headerName: "View Advance Details",
            field: "viewAdvanceDetails",
            cellRenderer: (params) => {
                if (params.data.partialPaymentIds && params.data.partialPaymentIds.length > 0) {
                    // Create a Popover to display the installment details
                    const popover = (
                        <Popover id={`popover-advance-${params.node.rowIndex}`}>
                            <Popover.Header as="h3">Advance Payment Details</Popover.Header>
                            <Popover.Body>
                                <Table striped bordered hover size="sm">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Invoice ID</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {params.data.partialPaymentIds.map((id, index) => (
                                            <tr key={id}>
                                                <td>{index + 1}</td>
                                                <td>{id}</td>
                                                <td>
                                                    <Button
                                                        variant="info"
                                                        size="sm"
                                                        onClick={() => window.open(`https://staffing.nithrajobs.com/invoiceDetails?i=${id}`, '_blank')}
                                                    >
                                                        View Invoice
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </Popover.Body>
                        </Popover>
                    );

                    return (
                        <OverlayTrigger trigger="click" placement="left" overlay={popover} rootClose>
                            <Button variant="secondary" size="sm">
                                View Advance Details
                            </Button>
                        </OverlayTrigger>
                    );
                }
                return "";
            },
            cellStyle: { textAlign: 'center' },
            width: 200
        },
        {
            headerName: "Invoice",
            field: "action",
            cellRenderer: (params) => (
                <Button variant="warning" size="sm" onClick={() => handleViewInvoice(params.data)}>
                    🧾
                </Button>
            ),
            width: 80,
        },
        { headerName: "Invoice Number", field: "invoiceNumber" },
        { headerName: "TransactionID", field: "transactionID" },
        { headerName: "Salary", field: "salary" },
        { headerName: "Percentage", field: "percentage" },
        { headerName: "Amount after %", field: "after_percentage" },
        { headerName: "Paid Amount", field: "paidAmount", valueFormatter: (params) => formatAmount(params.value) },
        { headerName: "CGST", field: "CGST", valueFormatter: (params) => formatAmount(params.value) },
        { headerName: "SGST", field: "SGST", valueFormatter: (params) => formatAmount(params.value) },
        { headerName: "Total Amount", field: "totalAmount", valueFormatter: (params) => formatAmount(params.value) },
        { headerName: "Payment Mode", field: "paymentMode" },


        //   {
        //     headerName: "Advance Payment Invoice Receipt",
        //     field: "advanceInvoiceReceipt",
        //     cellRenderer: (params) => {
        //       if (params.data.partialPaymentIds && params.data.partialPaymentIds.length > 0) {
        //         const advanceInvoiceId = params.data.partialPaymentIds[params.data.partialPaymentIds.length - 1];
        //         return (
        //           <Button variant="info" size="sm" onClick={() => window.open(`https://staffing.nithrajobs.com/invoiceDetails?i=${advanceInvoiceId}`, '_blank')}>
        //             View Advance Invoice
        //           </Button>
        //         );
        //       }
        //       return "";
        //     },
        //     cellStyle: { textAlign: 'center' },
        //     width: 220
        //   },

        {
            headerName: "Pay Date",
            field: "payDate",
            valueFormatter: (params) => {
                if (!params.value) return "";
                const date = new Date(params.value);
                return date.toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                });
            },
        },
        { headerName: "Candidate Count", field: "candidate_count" },
        { headerName: "Description", field: "description" },
        {
            headerName: "Created on",
            field: "createdAt",
            valueFormatter: (params) => {
                if (!params.value) return "";
                const date = new Date(params.value);
                return date.toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                });
            },
        },
    ];


    // Fetch data on component mount
    useEffect(() => {
        fetchTableData();
    }, []);


    // const fetchTableData = async () => {
    //     try {
    //         const [jobEmployer] = await Promise.all([ // jobRoleRes
    //             // Replace with actual API
    //             // fetchGetData('/master/get/title'),    // Replace with actual API
    //             fetchGetData('/master/get/employer/new')    // Replace with actual API
    //         ]);
    //         setEmployer(jobEmployer.data);

    //         const [employerStaff] = await Promise.all([
    //             fetchPostData('/billing/get/paidBill')
    //         ]);
    //         setExcelData(employerStaff.data);
    //     } catch (error) {
    //         console.error('Error fetching data:', error);
    //         // setErrorMessage('Error loading district and job role data.');
    //     }
    // };


    const fetchTableData = async () => {
        try {
            const [jobEmployerRes, billingRes, paymentRes, jobExecutive] = await Promise.all([
                fetchGetData('/master/get/employer/new'),
                fetchPostData('/billing/get/paidBill'),      // billing (full payment and advance+full)
                fetchPostData('/billing/get/advanceBill'),      // payment (advance payments only)
                fetchGetData('/master/get/executive')
            ]);
            setEmployer(jobEmployerRes.data);
            setJobExecutive(jobExecutive.data);

            // Merge the two arrays
            const mergedData = [
                ...billingRes.data.map(record => ({ ...record, collectionType: 'billing' })),
                ...paymentRes.data.map(record => ({ ...record, collectionType: 'payment' }))
            ];
            setAllData(mergedData);

            // Optionally, sort by createdAt descending
            // mergedData.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

            // setExcelData(mergedData);
            // console.log(mergedData)  

            // Sort by createdAt descending to get the latest record first
            mergedData.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

            // ✅ Keep only the latest record per vacancyName
            const uniqueVacancyMap = new Map();

            for (const item of mergedData) {
                if (!uniqueVacancyMap.has(item.vacancyName)) {
                    uniqueVacancyMap.set(item.vacancyName, item); // store only first (latest) occurrence
                }
            }

            const uniqueVacancyData = Array.from(uniqueVacancyMap.values());

            setExcelData(uniqueVacancyData);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };


    const validateForm = () => {
        // if (typeof noOfCandidates === "string") {
        //     noOfCandidates = noOfCandidates.trim();
        // } else {
        //     console.log("Invalid data type:", noOfCandidates);
        // }
        if (!companyName.trim()) return "Employer is required.";
        if (!vacancyName.trim()) return "Job Tiltle is required.";
        if (!noOfCandidates) return "No of Candidates is required.";
        if (!percentage) return "Percentage is required.";
        if (!paymentMode) return "Payment Mode is required.";
        if (!paidAmount) return "Paid Amount is required.";
        if (!transactionID) return "Transaction ID is required.";
        if (!CGST) return "CGST is required.";
        if (!SGST) return "SGST is required.";
        if (!totalAmount) return "Total Amount is required.";
        if (!payDate) return "Payment date is required.";
        return null;
    };
    const handleViewInvoice = (data) => {
        const invoiceID = data._id;
        if (!invoiceID) {
            alert("Employer ID not found!");
            return;
        }
        // window.location.href = `http://localhost:8080/invoiceDetails?employerId=${employerId}`;
        // window.open(`http://localhost:8080/invoiceDetails?i=${invoiceID}`, '_blank');
        window.open(`https://staffing.nithrajobs.com/invoiceDetails?i=${invoiceID}`, '_blank');

    };

    // const handleSubmit = async (event) => {
    //     event.preventDefault();
    //     const validationError = validateForm();
    //     if (validationError) {
    //         setErrorMessage(validationError);
    //         return;
    //     }
    //     // if (!employerPayProof) {
    //     //     alert("Please upload an image before submitting.");
    //     //     return;
    //     // }

    //     // Create a new FormData object and append all form fields to it
    //     const formData = new FormData();
    //     formData.append('companyId', companyName);
    //     formData.append('vacancyName', vacancyName);
    //     formData.append('noOfCandidates', noOfCandidates);
    //     formData.append('salary', salary);
    //     formData.append('paidAmount', paidAmount);
    //     formData.append('transactionID', transactionID);
    //     formData.append('percentage', percentage);
    //     formData.append('paymentMode', paymentMode);
    //     formData.append('CGST', CGST);
    //     formData.append('SGST', SGST);
    //     formData.append('totalAmount', totalAmount);
    //     formData.append('payDate', payDate);
    //     formData.append('description', description);
    //     formData.append('file', employerPayProof);
    //     // formData.append('companyName', selectedCompanyName);
    //     // formData.append('companyAddress', companyAddress);
    //     // formData.append('gstin', gstin);
    //     // formData.append('mobile', companyMobile);
    //     setLoading(true);
    //     try {

    //         // console.log(CGST)
    //         // return 1;
    //         const response = await fetchFormData('/billing/create/bill', formData, {
    //             'Content-Type': 'multipart/form-data',
    //         });

    //         if (response.success) {
    //             setSuccessMessage('Form submitted and processed successfully!');
    //             fetchTableData();
    //             setCompanyName('');
    //             setVacancyName('');
    //             setNoOfCandidates('');
    //             setSalary('');
    //             setPaidAmount('');
    //             setTransactionID('');
    //             setPercentage('');
    //             setPaymentMode('');
    //             setCGST('');
    //             setSGST('');
    //             setTotalAmount('');
    //             setPayDate('');
    //             setDescription('');
    //             setPreview(null);
    //             setEmployerPayProof(null); // Reset file state

    //             // Reset the input field
    //             if (fileInputRef.current) {
    //                 fileInputRef.current.value = null; // Clear the input value
    //             }
    //         } else {
    //             setErrorMessage('Form submission failed.');
    //         }
    //     } catch (error) {
    //         console.error('Error submitting the form:', error);
    //         // setErrorMessage('An error occurred while submitting the form.');
    //         setErrorMessage(JSON.stringify(error.message));
    //     } finally {
    //         setLoading(false);
    //     }

    //     setTimeout(() => {
    //         setErrorMessage(''); // Clear error message
    //         setSuccessMessage(''); // Clear success message
    //     }, 5000);
    // };



    // const handleSubmit = async (event) => {
    //     event.preventDefault();
    //     const validationError = validateForm();
    //     if (validationError) {
    //         setErrorMessage(validationError);
    //         return;
    //     }

    //     const formData = new FormData();
    //     formData.append('companyId', companyName);
    //     formData.append('vacancyName', vacancyName);
    //     formData.append('noOfCandidates', noOfCandidates);
    //     formData.append('salary', salary);
    //     formData.append('paidAmount', paidAmount);
    //     formData.append('transactionID', transactionID);
    //     formData.append('percentage', percentage);
    //             formData.append('amountAfterPercentage', amountAfterPercentage);

    //     formData.append('paymentMode', paymentMode);
    //     formData.append('CGST', CGST);
    //     formData.append('SGST', SGST);
    //     formData.append('totalAmount', totalAmount);
    //     formData.append('payDate', payDate);
    //     formData.append('description', description);
    //     formData.append('file', employerPayProof);

    //     setLoading(true);
    //     try {
    //         let response;
    //         if (isEditing) {
    //             // Perform Update
    //             formData.append('id', editRecordId);
    //             response = await fetchFormData('/billing/update/bill', formData);
    //         } else {
    //             // Perform Create
    //             response = await fetchFormData('/billing/create/bill', formData);
    //         }

    //         if (response.success) {
    //             setSuccessMessage(isEditing ? 'Updated successfully!' : 'Created successfully!');
    //             fetchTableData();
    //             resetForm();
    //         } else {
    //             setErrorMessage('Operation failed.');
    //         }
    //     } catch (error) {
    //         setErrorMessage(error.message);
    //     } finally {
    //         setLoading(false);
    //     }

    //     setTimeout(() => {
    //         setErrorMessage('');
    //         setSuccessMessage('');
    //     }, 5000);
    // };


    // In your React component (TrackEmployee.js)
    const handleSubmit = async (event) => {
        event.preventDefault();
        const validationError = validateForm();
        if (validationError) {
            setErrorMessage(validationError);
            return;
        }

        const formData = new FormData();
        formData.append('companyId', companyName);
        formData.append('vacancyName', vacancyName);
        formData.append('noOfCandidates', noOfCandidates);
        formData.append('salary', salary);
        formData.append('paidAmount', paidAmount);
        formData.append('transactionID', transactionID);
        formData.append('percentage', percentage);
        formData.append('amountAfterPercentage', amountAfterPercentage);
        formData.append('paymentMode', paymentMode);
        formData.append('CGST', CGST);
        formData.append('SGST', SGST);
        formData.append('totalAmount', totalAmount);
        formData.append('payDate', payDate);
        formData.append('description', description);
        formData.append('executive', executive);
        formData.append('file', employerPayProof);

        // Add flag to indicate if this is a full payment
        const numericPaidAmount = parseFloat(paidAmount.replace(/,/g, ''));
        const numericAmountAfterPercentage = parseFloat(amountAfterPercentage.replace(/,/g, ''));
        const isFullPayment = numericPaidAmount >= numericAmountAfterPercentage;
        formData.append('isFullPayment', isFullPayment);

        setLoading(true);
        try {
            let response;
            if (isEditing) {
                formData.append('id', editRecordId);
                response = await fetchFormData('/billing/update/bill', formData);
            } else {
                response = await fetchFormData('/billing/create/bill', formData);
            }

            if (response.success) {
                setSuccessMessage(isEditing ? 'Updated successfully!' :
                    (isFullPayment ? 'Invoice generated successfully!' : 'Advance payment recorded.'));
                fetchTableData();
                resetForm();
            } else {
                setErrorMessage('Operation failed.');
            }
        } catch (error) {
            setErrorMessage(error.message);
        } finally {
            setLoading(false);
        }

        setTimeout(() => {
            setErrorMessage('');
            setSuccessMessage('');
        }, 5000);
    };

    const resetForm = () => {
        setCompanyName('');
        setVacancyName('');
        setNoOfCandidates('');
        setSalary('');
        setPaidAmount('');
        setTransactionID('');
        setPercentage('');
        setPaymentMode('');
        setCGST('');
        setSGST('');
        setTotalAmount('');
        setPayDate('');
        setDescription('');
        setPreview(null);
        setEmployerPayProof(null);
        setIsEditing(false);
        setEditRecordId(null);
    };




    const handleSelectEmployerChange1 = (e) => {
        const selectedEmployerId = e.target.value;
        setCompanyName(selectedEmployerId)
        if (selectedEmployerId || true) {
            fetchData(selectedEmployerId); // Fetch data based on selected employer
        } else {
            // setVacancy([]);
        }
    };

    const handleSelectEmployerChange = (e) => {
        const selectedEmployerId = e.target.value;
        setCompanyName(selectedEmployerId)
        // setExcelData(tabIndex);
        if (selectedEmployerId) {
            fetchData(selectedEmployerId); // Fetch data based on selected employer
        } else {
            setVacancy([]);
        }
    };
    const handleImageChange = (e) => {
        const file = e.target.files[0];
        // if (!file) return;

        if (file.type.startsWith("image/")) {
            setEmployerPayProof(file);

            // Generate preview
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
        // alert("Please select an image file.");
        // return;
    };

    const handlePercentageChange = (e) => {
        let value = e.target.value;

        // Remove non-numeric characters
        value = value.replace(/\D/g, "");

        // Allow "100" but restrict other inputs to 2 digits
        if (value !== "100" && value.length > 2) {
            value = value.slice(0, 2);
        }

        // Prevent setting NaN or empty values
        setPercentage(value);
    };

    const handlePaidAmountChange = (e) => {
        let value = e.target.value;
        if (value > 1000000) {
            value = 1000000; // Restrict value to 10,00,000
        }
        // setPaidAmount(value);
        let totalAmount = parseFloat(e.target.value) || '';

        // Reverse GST Calculation
        let baseAmt = totalAmount / 1.18; // Get base price before GST
        let calculatedCGST = baseAmt * 0.09;
        let calculatedSGST = baseAmt * 0.09;


        // setPaidAmount(totalAmount);
        setPaidAmount(value);
        setTotalAmount(baseAmt.toFixed(2));
        setCGST(calculatedCGST.toFixed(2));
        setSGST(calculatedSGST.toFixed(2));

    };
    const gridRef = useRef(null);

    const handleDownload = () => {
        const selectedEmployer = jobEmployer.find(role => role.id.toString() === companyName)?.english;
        const selectedVacancy = jobVacancy.find(role => role._id.toString() === vacancyName)?.jobtitle;
        const optionsCSV = {
            // fileName: 'my-data-' + new Date().toISOString() + '.csv',
            fileName: 'employer_staff_' + new Date().toLocaleTimeString() + '.csv',
        };
        gridRef.current.api.exportDataAsCsv(optionsCSV);
    };
    // Format amount safely, handling both string and number inputs
    const formatAmount = (value) => {
        if (value == null) return '';

        if (typeof value === 'string') {
            value = Number(value.replace(/,/g, ''));
        }

        if (typeof value === 'number' && !isNaN(value)) {
            return value.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }

        return '';
    };

    const fetchData = async (selectedEmployerId) => {
        try {
            const [jobVacancy] = await Promise.all([
                fetchGetData('/employer/get/employer/vacancy', { id: selectedEmployerId })
            ]);
            setVacancy(jobVacancy.data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    return (
        <><div className="container mt-5">
            <Card className="p-4 shadow-sm">
                <h4 className="mb-4">Create Bill Vacancy</h4>
                {loading && (
                    <div className="text-center my-4">
                        <Spinner animation="border" />
                    </div>
                )}
                <Form onSubmit={handleSubmit}>
                    <Row className="mb-3">
                        <Col md={6}>
                            <Form.Group controlId="companyName">
                                <Form.Label>Choose employer <span className="text-danger">*</span></Form.Label>
                                <Form.Select
                                    value={companyName}
                                    // onChange={(e) => setCompanyName(e.target.value)}
                                    onChange={handleSelectEmployerChange}
                                    required
                                >
                                    <option value="">Choose employer</option>
                                    {jobEmployer.map(role => (
                                        <option key={role.id} value={role.id}>
                                            {role.english}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            {/* <Form.Group controlId="vacancyName" className="p-1">
                                <Form.Label>Choose Job Title <span className="text-danger">*</span></Form.Label>
                                <Form.Select
                                    value={vacancyName}
                                    onChange={(e) => setVacancyName(e.target.value)}
                                    required
                                >
                                    <option value="">Choose Job Title</option>
                                    {jobVacancy.map(role => (
                                        <option key={role._id} value={role._id}>
                                            {role.jobtitle || 'no title found'} [{role.count}] - {role.createdAt}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group> */}
                            <Form.Group controlId="vacancyName" className="p-1">
                                <Form.Label>Choose Job Title <span className="text-danger">*</span></Form.Label>
                                <Form.Select
                                    value={vacancyName}
                                    onChange={handleVacancyChange}
                                    required
                                >
                                    <option value="">Choose Job Title</option>
                                    {jobVacancy.map(role => (
                                        <option key={role._id} value={role._id}>
                                            {role.jobtitle || 'no title found'} [{role.count}] - {role.createdAt}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>

                        </Col>


                        <Col md={6}>
                            <Form.Group controlId="noOfCandidates">
                                <Form.Label>No of candidates <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="text"
                                    value={noOfCandidates}
                                    onChange={(e) => setNoOfCandidates(e.target.value)}
                                    minLength={1}
                                    maxLength={3}
                                    required
                                    placeholder="Enter no of candidates" />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="salary">
                                <Form.Label>Salary</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={salary}
                                    onChange={(e) => setSalary(e.target.value)}
                                    pattern="^(10000|[1-8][0-9]{4}|9[0-8][0-9]{3}|99000)$"
                                    title="Salary must be between 10000 and 99000"
                                    min="10000"
                                    // required
                                    placeholder="Enter salary" />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="percentage">
                                <Form.Label>Percentage(%) <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="number"
                                    value={percentage}
                                    onChange={handlePercentageChange}
                                    min="0"
                                    max="100"
                                    required
                                    placeholder="Enter percentage" />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="amountAfterPercentage">
                                <Form.Label>Amount after %</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={amountAfterPercentage}
                                    readOnly
                                    placeholder="Amount based on percentage"
                                />
                            </Form.Group>
                        </Col>

                        <Col md={6}>
                            <Form.Group controlId="payDate">
                                <Form.Label>Payment Date <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="date"
                                    value={payDate}
                                    onChange={(e) => setPayDate(e.target.value)}
                                    max={new Date().toISOString().split("T")[0]}
                                    required />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="paidAmount">
                                <Form.Label>Paid Amount <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="number"
                                    value={paidAmount}
                                    // onChange={(e) => setPaidAmount(e.target.value)}
                                    onChange={handlePaidAmountChange}
                                    title="Paid Amount"
                                    required
                                    placeholder="Enter Paid Amount"
                                    min="0"
                                    max="1000000" />
                            </Form.Group>
                        </Col>
                        {/* {paidAmount && (
    <Col md={6}>
        <Form.Group controlId="advancePending">
            <Form.Label>Advance Pending</Form.Label>
            <Form.Control
                type="text"
                value={advancePending}
                readOnly
                placeholder="Auto-calculated if Paid < Amount after %"
            />
        </Form.Group>
    </Col>
)} */}

                        <Col md={6}>
                            <Form.Group controlId="transactionID">
                                <Form.Label>Transaction ID <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="text"
                                    value={transactionID}
                                    onChange={(e) => setTransactionID(e.target.value)}
                                    title="Transaction ID"
                                    required
                                    placeholder="Enter Transaction ID"
                                    maxLength={30} />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="paymentMode">
                                <Form.Label>Payment Mode <span className="text-danger">*</span></Form.Label>
                                <Form.Select
                                    value={paymentMode}
                                    onChange={(e) => setPaymentMode(e.target.value)}
                                    required
                                >
                                    {modeArray.map((mode, index) => (
                                        <option key={index} value={mode.val}>
                                            {mode.name}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="mobile">
                                <Form.Label>Description</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3} // Number of rows for the textarea
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                    placeholder="Enter description" />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="executiveName">
                                <Form.Label>Executive <small className="text-danger">*</small></Form.Label>
                                <Form.Select
                                    value={executive}
                                    onChange={(e) => setExecutive(e.target.value)}
                                    required
                                >
                                    <option value="">Choose executive</option>
                                    {jobExecutive.map(role => (
                                        <option key={role.id} value={role.id}>
                                            {role.name}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group controlId="imageUpload">
                                <Form.Label>Upload Payment Proof Image </Form.Label>
                                <Form.Control
                                    type="file"
                                    accept="image/*"
                                    onChange={handleImageChange}
                                    ref={fileInputRef} // Attach ref here
                                />
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            {preview && (
                                <div className="mt-3">
                                    <p>Preview:</p>
                                    <img src={preview} alt="Preview" style={{ width: "200px", height: "auto", borderRadius: "10px" }} />
                                </div>
                            )}
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md={6}></Col>
                        <Col md={4}>
                            <Form.Group controlId="CGST">
                                <Form.Label>CGST (9%)</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={CGST}
                                    title="CGST"
                                    required
                                    disabled
                                    placeholder="Enter CGST" />
                            </Form.Group>
                        </Col>
                        <Col md={6}></Col>
                        <Col md={4}>
                            <Form.Group controlId="SGST">
                                <Form.Label>SGST (9%)</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={SGST}
                                    title="SGST"
                                    required
                                    disabled
                                    placeholder="Enter SGST" />
                            </Form.Group>
                        </Col>
                        <Col md={6}></Col>
                        <Col md={4}>
                            <Form.Group controlId="TotalAmount">
                                <Form.Label>Total Amount</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={totalAmount}
                                    title="Total Amount"
                                    required
                                    disabled
                                    placeholder="Enter Amount" />
                            </Form.Group>
                        </Col>
                    </Row>
                    <div className="text-end py-3">
                        &nbsp;&nbsp;
                        <Button type="submit" variant="primary" disabled={loading} onClick={(e) => {
                            if (!window.confirm('Are you sure you want to submit?')) {
                                e.preventDefault(); // Prevent form submission if the user cancels
                            }
                        }}>
                            {/* {loading ? 'Submitting...' : 'Submit'} */}
                            {loading ? 'Processing...' : isEditing ? 'Update' : 'Submit'}

                        </Button>
                    </div>
                </Form>
                {errorMessage && (
                    <Alert variant="danger" className="mt-3">
                        {errorMessage}
                    </Alert>
                )}
                {successMessage && (
                    <Alert variant="success" className="mt-3">
                        {successMessage}
                    </Alert>
                )}
            </Card>
        </div>
            <Container className="mt-5">
                <Row>
                    {/* Column 1: Checkboxes (col-3) */}
                    <Col md={12}>
                        <Tab.Container defaultActiveKey="tab2">
                            <Card>
                                <Card.Body>
                                    {excelData.length > 0 && (
                                        <Button className="mb-3" variant="primary" onClick={handleDownload}>
                                            Download CSV
                                        </Button>
                                    )}
                                    <div className="ag-theme-alpine" style={{ height: 800, width: '100%' }}>
                                        <style>
                                            {`
          .highlighted-button {
            background-color: #f0ad4e !important; /* Custom highlight color (e.g., orange) */
            border-color: #eea236;
          }
        `}
                                        </style>
                                        <AgGridReact
                                            ref={gridRef}
                                            columnDefs={columnsStaffing}
                                            rowData={excelData}
                                            pagination={true}
                                            domLayout="autoHeight"
                                            modules={[ValidationModule, ClientSideRowModelModule]}
                                            loading={loading}
                                        />
                                    </div>
                                </Card.Body>
                            </Card>
                        </Tab.Container>
                    </Col>
                    <Modal show={showModal} onHide={() => setShowModal(false)} size="xl" centered>
                        <Modal.Header closeButton>
                            {/* <Modal.Title>Records for Vacancy: {selectedVacancyName}</Modal.Title> */}
                            <Modal.Title>Payment details of { vacancyDetails.length > 0 ? vacancyDetails[0].companyName : '' }</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {vacancyDetails.length > 0 ? (
                                <Table striped bordered hover responsive>
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            {/* <th>Company Name</th> */}
                                            <th>Paid Amount</th>
                                            <th>Payment Type</th>
                                            <th>Payment Mode</th>
                                            <th>Pay Date</th>
                                            <th>Invoice No</th>
                                            <th>Transaction ID</th>
                                            <th>Description</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {vacancyDetails.map((item, index) => (
                                            <tr key={item._id || index}>
                                                <td>{index + 1}</td>
                                                {/* <td>{item.companyName}</td> */}
                                                <td>{item.paidAmount}</td>
                                                <td>
                                                    {item.collectionType === 'payment'
                                                        ? 'Advance Payment'
                                                        : item.partialPaymentIds?.length
                                                            ? 'Advance + Full Payment'
                                                            : 'Full Payment'}
                                                </td>
                                                <td>{item.paymentMode}</td>
                                                <td>{new Date(item.payDate).toLocaleDateString('en-GB')}</td>
                                                <td>{item.invoiceNumber}</td>
                                                <td>{item.transactionID}</td>
                                                <td>{item.description}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            ) : (
                                <p>No records found.</p>
                            )}
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => setShowModal(false)}>
                                Close
                            </Button>
                        </Modal.Footer>
                    </Modal>


                </Row>
            </Container></>
    );
};

export default TrackEmployee;
